module.exports = __webpack_public_path__ + "static/media/cert_111.64ecbfcb.jpg";